/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Sync_Debt_WarningInputs */

const vi_import_sync_debt_warning = /** @type {(inputs: Import_Sync_Debt_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nợ hiện tại của những khách trùng số điện thoại sẽ bị ghi đè bằng số trong file, và được ghi một bút toán điều chỉnh vào sổ công nợ. Chỉ bật khi nhập liệu lần đầu.`)
};

/**

* @param {Import_Sync_Debt_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_sync_debt_warning = /** @type {((inputs?: Import_Sync_Debt_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Sync_Debt_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_sync_debt_warning(inputs)
});